<!--检修订单-->
<template>
  <div id="repairRecords" class="business-content-main">
    <div class="bread-nav">
      <div>您当前位置：</div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客服</el-breadcrumb-item>
        <el-breadcrumb-item>检修管理</el-breadcrumb-item>
        <el-breadcrumb-item>检修订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="search-ctn">
      <div class="search-name">检修单号:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchData.OrderCode"
        placeholder="请输入检修单号"
      ></el-input>
      <div class="search-name">汽修厂:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchData.EntpName"
        placeholder="请输入汽修厂名称"
      ></el-input>
      <div class="search-name">车主:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchData.ClientName"
        placeholder="请输入车主名称或手机号"
      ></el-input>
      <div class="search-name">车牌号:</div>
      <el-input
        style="width: 180px"
        class="search-item"
        size="small"
        v-model.trim="searchData.CarNum"
        placeholder="请输入车牌号"
      ></el-input>
      <!-- <div class="search-name">时间:</div>
      <el-date-picker
        :picker-options="startDateOps"
        class="search-item"
        v-model="searchData.StartDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="date"
        size="small"
        placeholder="选择日期"
      ></el-date-picker>
      <span class="search-name">至</span>
      <el-date-picker
        :picker-options="endDateOps"
        class="search-item"
        v-model="searchData.EndDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="date"
        size="small"
        placeholder="选择日期"
      ></el-date-picker> -->
        <div class="search-name">预约类型:</div>
      <el-select size="small" class="search-item" v-model="searchData.ReservationType" placeholder="请选择">
        <el-option
          v-for="item in reservationTypes"
          :key="item.Tkey"
          :label="item.TValue"
          :value="item.Tkey"
        ></el-option>
      </el-select>
      <div class="search-name">状态:</div>
      <el-select size="small" class="search-item" v-model="searchData.State" placeholder="请选择">
        <el-option
          v-for="item in orderState"
          :key="item.Tkey"
          :label="item.TValue"
          :value="item.Tkey"
        ></el-option>
      </el-select>
      <div>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          class="search-btn"
          @click="handleSearch"
        >查询</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-refresh"
          class="search-btn"
          @click="resetSearch"
        >重置</el-button>
      </div>
    </div>
    <div class="table-ctn">
      <el-table
        :header-cell-style="{background:'#F2F6FC'}"
        :data="recordsList"
        border=""
        style="width: 100%"
      >
        <el-table-column width="190px" show-overflow-tooltip prop="OrderCode" label="单号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="EntpName" label="汽修厂"></el-table-column>
        <el-table-column show-overflow-tooltip prop="ClientName" label="车主"></el-table-column>
        <el-table-column show-overflow-tooltip prop="ClientPhone" label="车主电话"></el-table-column>
        <el-table-column show-overflow-tooltip prop="CarNum" label="车牌号"></el-table-column>
        <el-table-column show-overflow-tooltip label="创建时间">
          <template slot-scope="scope">{{ scope.row.CreateTime|formatDate}}</template>
        </el-table-column>
         <el-table-column show-overflow-tooltip prop="ReservationTypeName" label="预约类型"></el-table-column>
        <el-table-column show-overflow-tooltip label="状态">
          <template slot-scope="scope">{{ scope.row.StateName}}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              v-if="scope.row.OrderState===3 && permission.审核&&scope.row.IsCancel===false"
              @click="handleReview(scope.row)"
            >审核</el-button>
            <el-button type="text" size="small" v-if="scope.row.OrderState!==3||scope.row.IsCancel===true" @click="handleReview(scope.row)">查看</el-button>
            <el-button
              type="text"
              size="small"
              style="color:#f56c6c;"
              v-if="scope.row.IsCancel===false&& permission.关闭"
              @click="closeOrderDialog(scope.row,scope.$index)"
            >关闭</el-button>
            <el-button
              type="text"
              size="small"
              v-if="scope.row.IsCancel===true"
              @click="viewClosedReason(scope.row.OrderId)"
            >查看关闭原因</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-ctn">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchData.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="searchData.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchData.totalCount"
      ></el-pagination>
    </div>
    <el-dialog title="关闭检修订单" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <div class="dialog-content">
        <el-form :model="closeOrderFormData" ref="closeOrderForm" label-width="80px" size="mini">
          <el-form-item
            label="原因"
            prop="cancelReason"
            :rules="[{ required: true, message: '请输入关闭原因'}]"
          >
            <el-input
              v-model="closeOrderFormData.cancelReason"
              autocomplete="off"
              type="textarea"
              placeholder="请输入关闭原因"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('closeOrderForm')">取 消</el-button>
        <el-button type="primary" @click="saveCloseOrder('closeOrderForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看关闭原因" :close-on-click-modal="false" :visible.sync="reasonDialogVisible" @close="reasonFormData = {}">
      <div class="dialog-content">
        <el-form
          :model="reasonFormData"
          ref="reasonForm"
          label-width="100px"
          size="mini"
          v-loading="formloading"
        >
          <el-form-item label="关闭人类型：">
            <label>{{reasonFormData.operatorType}}</label>
          </el-form-item>
          <el-form-item label="关闭人：">
            <label>{{reasonFormData.operatorName}}</label>
          </el-form-item>
          <el-form-item label="关闭时间：">
            <label>{{reasonFormData.cancelTime}}</label>
          </el-form-item>
          <el-form-item label="原因：">
            <label>{{reasonFormData.cancelReason}}</label>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "repairRecords",
  data() {
    return {
      startDateOps: {
        disabledDate: time => {
          if (this.searchData.EndDate != "") {
            return time.getTime() > new Date(this.searchData.EndDate);
          }
        }
      },
      endDateOps: {
        disabledDate: time => {
          if (this.searchData.StartDate != "") {
            return time.getTime() < new Date(this.searchData.StartDate);
          }
        }
      },
       reservationTypes: [
        { Tkey: -1, TValue: "请选择" },
        { Tkey: 0, TValue: "到店检修" },
        { Tkey: 1, TValue: "上门检修" },
        { Tkey: 2, TValue: "公路救援" }
      ],
      orderState: [
        { Tkey: -1, TValue: "请选择" },
        { Tkey: 3, TValue: "待审核" },
        { Tkey: 0, TValue: "已审核" },
        { Tkey: 4, TValue: "已关闭" }
      ],
      searchData: {
        OrderCode: "",
        EntpName: "",
        ClientName: "",
        CarNum: "",
        State: -1,
        ReservationType:-1,
        // StartDate: "",
        // EndDate: "",
        page: 1, // 当前页数
        limit: 10, // 每页限制条数
        totalCount: 0
      },
      recordsList: [],
      permission: {},
      dialogFormVisible: false,
      closeOrderFormData: { orderId: "", cancelReason: "", index: 0 },
      reasonDialogVisible: false,
      reasonFormData: {},
      formloading: false
    };
  },
  mounted() {
    this.getRecordsList();
    this.$util.getPermission("检修订单").then(res => {
      this.permission = res;
    });
  },
  methods: {
    handleSearch() {
      this.searchData.page = 1;
      this.getRecordsList();
    },
    getRecordsList() {
      this.axios
        .get("/RepairManagement/GetRepairRecordsList", {
          params: this.searchData
        })
        .then(result => {
          this.recordsList = result.data.data;
          this.searchData.totalCount = result.data.count;
        });
    },
    resetSearch() {
      this.searchData = {
        OrderCode: "",
        EntpName: "",
        ClientName: "",
        CarNum: "",
        State: -1,
        ReservationType:-1,
        // StartDate: "",
        // EndDate: "",
        page: 1, // 当前页数
        limit: 10 // 每页限制条数
      };
    },
    handleSizeChange(val) {
      this.searchData.page = 1;
      this.searchData.limit = val;
      this.getRecordsList();
    },
    handleCurrentChange(val) {
      this.searchData.page = val;
      this.getRecordsList();
    },
    handleReview(val) {
      //this.$router.push({name: '/business/repairOrders/repairRecordDetail',params:{}});
      this.$router.push(
        "/business/repairManagement/repairRecordDetail?OrderId=" + val.OrderId
      );
    },
    //查看关闭原因
    viewClosedReason(oid) {
      this.reasonDialogVisible = true;
      this.formloading = true;
      this.axios
        .get("/RepairManagement/GetCancelReason?oid=" + oid, {data:true})//data=true表示不启用遮罩层
        .then(result => {
          if (result.data.errcode == 0) {
            this.reasonFormData = result.data.data;
          }
          this.formloading = false;
        })
        .catch(err => {
          this.reasonFormData = {};
          this.formloading = false;
        });
    },
    //打开关闭订单弹窗
    closeOrderDialog(row, index) {
      this.dialogFormVisible = true;
      this.closeOrderFormData.orderId = row.OrderId;
      this.closeOrderFormData.cancelReason = "";
      this.closeOrderFormData.index = index;
    },
    //保存关闭订单
    saveCloseOrder(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let _formData = {
            OrderId: that.closeOrderFormData.orderId,
            CancelReason: that.closeOrderFormData.cancelReason
          };
          this.axios
            .post("/RepairManagement/CancelRepairOrder", _formData)
            .then(res => {
              let result = res.data;
              if (result.errcode == 0 && result.data) {
                this.recordsList[that.closeOrderFormData.index].IsCancel = true;
                this.recordsList[that.closeOrderFormData.index].StateName = "已关闭";
                this.$util.successMsg("关闭成功");
                this.dialogFormVisible = false;
              } else {
                this.$util.errorMsg("关闭失败");
              }
            })
            .catch(error => {
              this.$util.errorMsg("关闭失败");
            });
        }
      });
    },
    //取消关闭订单弹窗
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs[formName].clearValidate();
      this.dialogFormVisible = false;
    }
  }
};
</script>
